import api from '../services/api';

export async function getUsers(queryParams) {
  try {
    let endpoint = '/api/users';
    if (queryParams && queryParams.toString()) {
      endpoint += `?${queryParams.toString()}`;
    }
    const response = await api.get(endpoint);
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
}

export async function getUserById(id) {
  try {
    const response = await api.get(`/api/users/${id}`); 
    return response.data;
  } catch (error) {
    console.error(`Error fetching user ${id}:`, error);
    throw error;
  }
}

export async function createUser(userData) {
  try {
    const response = await api.post('/api/users/save', userData); 
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
}

export async function updateUser(id, userData) {
  try {
    userData.user_id = id; // Add the user_id to the data
    console.log('Data being sent to API:', userData);
    const response = await api.post('/api/users/update', userData); 
    return response.data;
  } catch (error) {
    console.error(`Error updating user ${id}:`, error);
    throw error;
  }
}

export async function deleteUser(id) {
  try {
    const response = await api.delete(`/api/users/${id}`); 
    return response.data;
  } catch (error) {
    console.error(`Error deleting user ${id}:`, error);
    throw error;
  }
}

export async function getDivisions() {
  try {
    const response = await api.get('/api/users/departments');
    return response.data;
  } catch (error) {
    console.error('Error fetching divisions:', error);
    throw error;
  }
}

export async function getDepartments() {
  try {
    const response = await api.get('/api/users/departments');
    return response.data;
  } catch (error) {
    console.error('Error fetching departments:', error);
    throw error;
  }
}

export async function getRoles() {
  try {
    const response = await api.get('/api/users/roles');
    return response.data;
  } catch (error) {
    console.error('Error fetching roles:', error);
    throw error;
  }
}

export async function getProfile() {
  try {
    const response = await api.get('/api/profile');
    return response.data;
  } catch (error) {
    console.error('Error fetching profile:', error);
    throw error;
  }
}

export async function updateProfile(profileData) {
  try {
    const response = await api.put('/api/profile', profileData);
    return response.data;
  } catch (error) {
    console.error('Error updating profile:', error);
    throw error;
  }
}

export async function changePassword(passwordData) {
  try {
    const response = await api.post('/api/users/change_password', passwordData);
    return response.data;
  } catch (error) {
    console.error('Error changing password:', error);
    throw error;
  }
}

export async function getCreateUserForm() {
  try {
    const response = await api.get('/api/users/create');
    return response.data;
  } catch (error) {
    console.error('Error fetching create user form data:', error);
    throw error;
  }
}

export async function getEditUserForm(id) {
  try {
    const response = await api.get(`/api/users/edit/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching edit user form data for ${id}:`, error);
    throw error;
  }
}

export async function searchUsers(queryParams) {
  try {
    let endpoint = '/api/users/search';
    if (queryParams && queryParams.toString()) {
      endpoint += `?${queryParams.toString()}`;
    }
    const response = await api.get(endpoint);
    return response.data;
  } catch (error) {
    console.error('Error searching users:', error);
    throw error;
  }
}

export async function exportUsers(queryParams) {
  try {
    let endpoint = '/api/users/export';
    if (queryParams && queryParams.toString()) {
      endpoint += `?${queryParams.toString()}`;
    }
    const response = await api.get(endpoint, {
      responseType: 'blob'
    });
    return response.data;
  } catch (error) {
    console.error('Error exporting users:', error);
    throw error;
  }
}

export async function getUserStatistics() {
  try {
    const response = await api.get('/api/users/statistics');
    return response.data;
  } catch (error) {
    console.error('Error fetching user statistics:', error);
    throw error;
  }
}

export async function getAllActiveUsers() {
  try {
    const response = await api.get('/api/users', {
      params: {
        page: 1,
        pageSize: 1000
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching all active users:', error);
    throw error;
  }
}

export async function bulkOperations(operationData) {
  try {
    const response = await api.post('/api/users/bulk_operations', operationData);
    return response.data;
  } catch (error) {
    console.error('Error performing bulk operations:', error);
    throw error;
  }
}

export async function getDepartmentUsers(departmentId) {
  try {
    const response = await api.get(`/api/users/department_users/${departmentId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching department users for ${departmentId}:`, error);
    throw error;
  }
}

// Utility to split departments and divisions from a flat list
export function splitDepartmentsAndDivisions(departments) {
  // Departments: division_department is 0 or null
  const parentDepartments = departments.filter(d => !d.division_department || d.division_department === 0);
  // Divisions: division_department is set
  const divisions = departments.filter(d => d.division_department && d.division_department !== 0);
  return { departments: parentDepartments, divisions };
}

// Axios response interceptor to handle 401 errors
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      const originalRequestUrl = error.config.url;
      // Don't redirect on 401 for session check or login endpoints
      if (originalRequestUrl.endsWith('/api/check_session') || originalRequestUrl.endsWith('/api/auth/login')) {
        return Promise.reject(error); // Reject the promise to allow the caller to handle it
      }
      
      // For all other 401s, redirect to login
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
